import { observer } from 'mobx-react';
import mealsStore from '../../store/mealsStore';
import Text, { TEXT } from 'src/view/components/Text/Text';

const MealsValidationMessages: React.FC = observer((): JSX.Element => {
  return (
    <div className="d-flex flex-column">
      {mealsStore.meal?.sizes.length && mealsStore.meal?.groups.length ? null : <Text type={TEXT.RECOMMENDATION} text="pls_add_mc_size_and_group" />}
      {mealsStore.validation.sizesLength ? null : <Text type={TEXT.ERROR} text="min_1_cmsize_needed_error" />}
      {mealsStore.validation.sizesLength && mealsStore.validation.groupsLength ? null : <Text type={TEXT.ERROR} text="min_1_cmgroup_needed_error" />}
    </div>
  );
});

export default MealsValidationMessages;
